import { useLocation } from 'react-router-dom';
import React from 'react';
import type { Location } from '@remix-run/router';
import { trackPageView } from '../../lib/app/analytics/ga';

const PageTracker = () => {
  const location: Location = useLocation();

  React.useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default PageTracker;
